import http, {objectToFormData} from './http';

export default {
  all() {
    return http().get(`/v1/communication_logs`);
  },
  allForRecord(record_id) {
    return http().get(`/v1/communication_logs?record_id=${record_id}`);
  },
  lastCall(contactId) {
    return http().get(`/v1/communication_logs/${contactId}/contact/last_call`)
  },
  lastText(contactId) {
    return http().get(`/v1/communication_logs/${contactId}/contact/last_text`)
  },
  getRecording(comLogId) {
    return http().get(`/v1/communication_logs/${comLogId}/recording`)
  },
  getTranscript(comLogId) {
    return http().get(`/v1/communication_logs/${comLogId}/transcript`)
  },
  allForContact(contactId) {
    return http().get(`/v1/communication_logs/${contactId}/contact`)
  },
  setAddressed(data) {
    return http().put(`/v1/communication_logs/${data.id}/set_addressed`, data);
  },
  setAllAddressed(data) {
    return http().post(`/v1/communication_logs/set-all-addressed`, data)
  },
  get(id) {
    return http().get(`/v1/communication_logs/${id}`);
  },
  getRecords(id) {
    return http().get(`/v1/communication_logs/${id}/records`);
  },
  getFromUrl(url) {
    return http().get(url);
  },
  emailContact(payload, validationErrors) {
    let formData = objectToFormData(payload)
    return http(validationErrors).post(`/v1/communication_logs/email/${payload.id}`, formData);
  },
  scheduledEmailContact(payload, validationErrors) {
    // we are converting date object to string
    // so it will be included when parsing the payload into FormData
    if (typeof payload.datetime !== 'string') {
      payload.datetime = payload.datetime.toISOString()
    }

    let formData = objectToFormData(payload)
    return http(validationErrors).post(`/v1/communication_logs/scheduled-email/${payload.id}`, formData);
  },
  cancelSchedule(id) {
    return http().delete(`/v1/communication_logs/cancelled/${id}`);
  },
  attachToRecord(id, data, validationErrors) {
    return http(validationErrors).put(`/v1/communication_logs/${id}/assign_to_record`, data);
  },
  attachCommsToRecord(data, validationErrors) {
    return http(validationErrors).post(`/v1/communication_logs/assign_all_to_record`, data);
  }
}
